import "./components";
import "./app.scss";

// there is no main App initialization its all just custom element components


// do this to prevent Flash Of Unstyled Content (FOUC)
// as we are not serving a whole Vue app, v-cloak is not removed on initialization
document.addEventListener('vite-script-loaded', function (e) {
  const el = document.querySelector('#app');
  el?.removeAttribute('v-cloak-custom')
});